export const availabilityQueryKeys = {
  all: ['collaborators', 'availabilities'] as const,
  list: () => [...availabilityQueryKeys.all, 'list'] as const,
  detail: (availabilityId: string) =>
    [...availabilityQueryKeys.all, 'detail', availabilityId] as const,
};
